export default __webpack_public_path__ + "static/media/PPI-firefeature-003.8b88a1d1.jpg";